module.exports = __webpack_public_path__ + "static/media/arrow-back.396c3bc5.svg";